import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

type TableProps = ComponentProps<'table'>

export function Table(props: TableProps) {
    return (
        <div className='flex mx-auto mb-24 items-center border border-ochre_accent rounded-md md:justify-center'>
            <table className='text-sm p-2 w-full' {...props}>
            </table>
        </div>
    )
}

type TableHeaderProps = ComponentProps<'th'>

export function TableHeader(props: TableHeaderProps) {
    return (
        <th {...props}
            className={twMerge('py-3 px-4 text-center justify-center sm:text-left font-semibold text-sm', props.className)}
        >
        </th>
    )
}


type TableCellProps = ComponentProps<'td'>

export function TableCell(props: TableCellProps) {
    return (
        <td {...props}
            className={twMerge('p-4 bg-transparent items-center justify-center text-left', props.className)}
        >
        </td>
    )
}

type TableRowProps = ComponentProps<'tr'>

export function TableRow(props: TableRowProps) {
    return (
        <tr {...props}
            className={twMerge('flex flex-col md:table-row border-ochre_accent bg-transparent items-center justify-center text-left', props.className)}
        >
        </tr>
    )
}